class CounterInput {
  constructor($el) {
    this.$el = $el;
    this.$increment = this.$el.find('[data-counter-input="increment"]');
    this.$decrement = this.$el.find('[data-counter-input="decrement"]');
    this.$input = this.$el.find('[data-counter-input="input"]');

    this.val = Number(this.$input.val());
    this.step = Number(this.$input.attr('step'));

    this.init();
  }

  init = () => {
    console.log('counterInput', this);

    this.$decrement.on('click', this.decrement);
    this.$increment.on('click', this.increment);

    this.$input.on('change', this.updateVal);
  };

  decrement = () => {
    if(this.val <= 1) return;
    this.val = this.val - this.step;
    this.$input.val(this.val);
    this.$input.trigger('change');
  };

  increment = () => {
    this.val = this.val + this.step;
    this.$input.val(this.val);
    this.$input.trigger('change');
  };

  updateVal = () => {
    this.val = Number(this.$input.val());
  };


}

export default CounterInput;